import { render, staticRenderFns } from "./empresa-defensivo.vue?vue&type=template&id=1590b052&"
import script from "./empresa-defensivo.vue?vue&type=script&lang=js&"
export * from "./empresa-defensivo.vue?vue&type=script&lang=js&"
import style0 from "./empresa-defensivo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports